<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-9">

                <hr>

                Find anything wrong? Send a message on:&nbsp;
                <a href="https://discord.gg/88EdHfT8FT">
                    <i class="bi bi-discord"></i>
                    Discord
                </a>

                <br>

                Contributions are welcome
                <a href="https://github.com/Jessi810/CODM-Calc">
                    <i class="bi bi-github"></i>
                    Github
                </a>

            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
